import { IncentiveOffersListProvider } from '../pages/IncentiveOffersList/context/IncentiveOffersListContext';
import IncentiveOffersList from '../pages/IncentiveOffersList';

const IncentiveOffersListContainer = () => (
  <IncentiveOffersListProvider>
    <IncentiveOffersList />
  </IncentiveOffersListProvider>
);

export default IncentiveOffersListContainer;
